<nav class="navbar navbar-static-top">
  <div class="container">
    <div>
      <a class="navbar-brand" href={{headerData?.logo?.fields?.url}} target="_blank" rel="noopener">
        <img class="logo" src={{headerData?.logo?.fields?.image?.fields?.file?.url}} alt={{headerData?.logo?.fields?.alt}} />
      </a>
    </div>
    <ul class="navbar-nav" style="margin-left: auto">
      <li class="nav-item">
        <a class="nav-link text-white" id="analytics_cta" (click)="changeLang()"
          ><span>{{ engLang === true ? "English" : "Français" }}</span></a
          >
        </li>
      </ul>
    </div>
  </nav>
  <br />
  <div class="content">
    <router-outlet />
    <app-collapse></app-collapse>
  </div>

  <footer class="footer apply-border">

    <div
      id="footer"
      class="container-fluid"
      style="border-top: 8px solid #da291c"
      >
      <div class="container text-dark mt-2 py-3" data-swiftype-index="false">
        <div
          class="row d-flex flex-row justify-content-start align-items-center py-1"
          >
          <div
            class="col-md-3 col-12 order-md-1 order-2 pt-md-0 pt-2 align-self-center"
            >
            <a
              target="_blank"
              class="d-grid align-middle mr-4"
              href="https://www.rogers.com"
              rel="noopener"
              >
              <img
                class="rogers-logo"
                alt="Rogers logo"
                style="height: 25px"
                data-no-retina=""
                src="assets/footerLogo.svg"
                />
              </a>
            </div>
            <div
              class="col-md-9 col-12 order-md-2 order-2 justify-content-end align-self-center"
              >
              <ul class="list-inline pl-0">
                @for (item of footerlinks; track item) {
                  <li
                    class="list-unstyled list-inline-item"
                    >
                    <a
                      class="d-grid align-middle mr-4"
                      style="font-size: 14px; color: #1f1f1f; margin-right: 15px"
                      href="{{ item.fields.url }}"
                      target="_blank"
                      rel="noopener"
                      >
                      {{ item.fields.text }}
                    </a>
                  </li>
                }

              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid bg-dark">
        <div class="container text-white" data-swiftype-index="false">
          <div
            class="row d-flex flex-row justify-content-between align-items-center py-1"
            >
            <div class="col-12 pt-md-0 mt-2">
              <p class="text-white" style="font-size: 14px">
                {{ copyRight }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <app-loader></app-loader>
